import { zodResolver } from '@hookform/resolvers/zod';
import {
  type UseFormProps,
  type UseFormReturn,
  // eslint-disable-next-line canonical/no-restricted-imports
  useForm as useReactHookForm,
} from 'react-hook-form';
import { type z, type ZodTypeAny } from 'zod';

type Props<TSchema extends ZodTypeAny> = Omit<
  UseFormProps<z.infer<TSchema>>,
  'resolver'
> & {
  schema: TSchema;
};

export const useForm = <TSchema extends ZodTypeAny>(
  props: Props<TSchema>,
): UseFormReturn<z.infer<TSchema>> => {
  const { schema, ...rest } = props;

  return useReactHookForm({
    ...rest,
    resolver: zodResolver(schema),
  });
};
